import React, { useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, Typography, Box, MenuItem } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { SelectedMenu } from 'components'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import PropTypes from 'prop-types'
import { team as teamModule } from '../../redux/modules'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: 'auto',
    padding: theme.spacing(4),
    marginBottom: '1rem',
  },
  title: {
    paddingBottom: theme.spacing(0.5),
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginRight: 0,
      marginLeft: 0,
      '& > :nth-child(1)': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
  formControl: {
    marginLeft: '20px',
    maxWidth: '160px',
  },
}))

const PlayerEventResponse = ({ team, patchTeam }) => {
  const classes = useStyles()
  const [cutoffTime, setCutoffTime] = useState(0)
  const cutoffTimeOptions = [0, 1, 3, 6, 12, 24, 48]
  const featureGuard = useFeatureAccessGuard()

  const { enabled: hasCutoffTimeEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.cutoff_time_enabled
  )

  const handleCutoffTimeChange = (event) => {
    if (featureGuard(hasCutoffTimeEnabled)) return

    const { value } = event.target
    setCutoffTime(value)
    patchTeam(team.uuid, { availability_cutoff_time: value })
  }

  useMemo(() => {
    if (hasCutoffTimeEnabled) {
      setCutoffTime(team.availability_cutoff_time)
    }
  }, [team])

  return (
    <>
      <Card className={classes.root}>
        <Box>
          <Typography variant="h3" component="h3" className={classes.title}>
            <Translate id="player.event-response.title" />
            {!hasCutoffTimeEnabled ? (
              <LockIconComponent context="label" />
            ) : null}
          </Typography>
          <Typography variant="h6" component="h6">
            <Translate id="player.event-response.select-default" />
          </Typography>
        </Box>
        <Box className={classes.section}>
          <Typography variant="h4" component="h4">
            <Translate id="player.event-response.override-message" />
          </Typography>

          <SelectedMenu
            id="event-response.cutoff-time"
            value={cutoffTime}
            style={{ width: 180 }}
            onChange={handleCutoffTimeChange}
            label={<Translate id="player.event-response.cutoff-time" />}
            IconComponent={
              !hasCutoffTimeEnabled
                ? (props) => (
                    <LockIconComponent
                      context="select"
                      style={{ transform: 'none', transition: 'none' }} // Prevent lock icon rotation
                      {...props}
                    />
                  )
                : ArrowDropDownIcon
            }
          >
            {cutoffTimeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option === 0 ? (
                  <Translate id="player.event-response.disabled" />
                ) : (
                  <>
                    {option} <Translate id="player.event-response.hours" />
                  </>
                )}
              </MenuItem>
            ))}
          </SelectedMenu>
        </Box>
      </Card>
    </>
  )
}

PlayerEventResponse.propTypes = {
  patchTeam: PropTypes.func.isRequired,
  team: PropTypes.shape().isRequired,
}

export default connect(
  ({ team }) => ({
    team,
  }),
  {
    patchTeam: teamModule.patchTeam,
  }
)(PlayerEventResponse)
